export default "__VITE_ASSET__DQQc55fe__"